import React from "react";
import { RiMailFill, RiLinkedinBoxFill, RiGithubFill} from 'react-icons/ri';
import { DiReact } from 'react-icons/di';



export default function FooterOne() {
    return (
        <footer className="portfolio-footer">

            <div className="container">
                <small className="text-center c-white mb-3 mt-3">Contacto</small>

                <div className="portfolio-footer__social-media">
                    <a className="portfolio-footer__social-media__link" aria-label="mail" href="mailto:esmenava.dev@gmail.com"><RiMailFill /></a>
                    <a className="portfolio-footer__social-media__link" aria-label="link" href="https://www.linkedin.com/in/esme-nava/" target="_blank" rel="noopener noreferrer"><RiLinkedinBoxFill /></a>
                    <a className="portfolio-footer__social-media__link" aria-label="link" href="https://github.com/emeraldng" target="_blank" rel="noopener noreferrer"> <RiGithubFill /></a>
                    
                </div>
                <hr />
                {(() => {
                    const year = new Date().getFullYear();
                    return (
                        // <small>Made & Desing with <span>ReactJS <DiReact /></span> by Esmeralda Nava {year} ©</small>
                         <small>Designed and built by Esmeralda Nava © {year}</small>
                    );
                })()}
            </div>
        </footer>
    )
}